import { createSlice } from "@reduxjs/toolkit";
import { BecomePartnerAPI } from "../../services/become-partner";

const BecomePartner = createSlice({
  name: "Become partner",
  initialState: {
    partners: [],
    total: 0,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(BecomePartnerAPI.get.fulfilled, (state, action) => {
      const { total, become_partners } = action.payload;

      state.total = total;
      state.partners = become_partners;
    });
  },
});

export default BecomePartner;
